// src/constants/roleConstants.js

export const SAFETY_STOCK_ROLES = [
  { value: "Business Super User", label: "Business Super User" },
  { value: "IT Support", label: "IT Support" },
  { value: "SSA Admin", label: "SSA Admin" },
  { value: "Approver", label: "Approver" },
  { value: "Planner", label: "Planner" },
];

export const AL_CONTRACT_MANAGEMENT_ROLES = [
  { value: "CPS-AL-ContractAutomation-MOP-Analyst-Group", label: "MOP-Analyst" },
  { value: "CPS-AL-PRICEMEMO-OWNER-CEPG", label: "Price Memo Owner (CEPG)" },
  { value: "CPS-AL-PRICEMEMO-VIEWER-CEPG", label: "Price Memo Viewer (CEPG)" },
  { value: "CPS-AL-CONTRACTAUTOMATION-ANALYST-Group", label: "Contract Automation Analyst" },
  { value: "CPS-AL-PRICEMEMO-OWNER-PACKAGING", label: "Price Memo Owner (Packaging)" },
  { value: "CPS-AL-PRICEMEMO-VIEWER-PACKAGING", label: "Price Memo Viewer (Packaging)" },
  { value: "CM IT Support", label: "IT Support" },
  { value: "CD VIEWER", label: "Viewer" },
];

export const AL_SUPPLIER_COLLABORATION_ROLES = [
  { value: "AL-SupplierCollaboration-Admin-Group", label: "App Admin" },
  { value: "CPS-AL-SupplierCollaboration-Planner-Group::global", label: "Global Planner" },
  { value: "CPS-AL-SupplierCollaboration-Planner-Group", label: "Planner" },
  { value: "CPS-AL-SupplierCollaboration-Viewer-Group::global", label: "Global Viewer" },
  { value: "CPS-AL-SupplierCollaboration-Viewer-Group::regional", label: "Viewer" },
];

export const GRPT_ROLES = [
  { value: "CPS-AL-GRPT-Admin-Group", label: "Admin" },
  { value: "CPS-AL-GRPT-Planner-grpt-Group", label: "Quality-GRPT" },
  { value: "CPS-AL-GRPT-Planner-ptf-Group", label: "Planner-PTF" },
  { value: "CPS-AL-GRPT-Quality-aid-Group", label: "Quality-AID" },
  { value: "CPS-AL-GRPT-Approver-Group", label: "Approver" },
  { value: "CPS-AL-GRPT-Viewer-Group", label: "Viewer" },
];

export const LEAD_TIME_ANALYTICS_ROLES = [
  { value: "CPS-AL-LeadTime-<PLANTNUMBER>-Admin-Group", label: "Admin" },
  { value: "CPS-AL-LeadTime-<PlantNumber>-Approver-Group", label: "Approver" },
  { value: "CPS-AL-LeadTime-<PlantNumber>-Planner-Group", label: "Planner" },
  { value: "CPS-AL-LeadTime-GMP-Group", label: "GMP" },
  { value: "LT IT Support", label: "IT Support" },
  { value: "LT VIEWER", label: "Viewer" },
];

export const PO_MAINTENANCE_ROLES = [
  { value: "CPS-AL-POAutomation-Admin-Group", label: "Admin" },
  { value: "CPS-AL-POAutomation-Planner-Group", label: "Planner" },
  { value: "CPS-AL-POAutomation-Viewer-Group", label: "Viewer" },
  { value: "IT Support", label: "IT Support" },
];

export const INVENTORY_REBALANCING_ROLES = [
  { value: "Planner", label: "Planner" },
  { value: "Viewer", label: "Viewer" },
  { value: "IT Support", label: "IT Support" },
];

export const OM_LOAD_OPTIMISATION_ROLES = [
  { value: "Planner", label: "Planner" },
  { value: "Bottler", label: "Bottler" },
  { value: "Dispatcher", label: "Dispatcher" },
  { value: "IT Support", label: "IT Support" },
];

export const getRolesForApplication = (appType) => {
  if (!appType) return [];

  const app = String(appType).trim();

  switch (app) {
    case "IO - Safety Stock Approval":
      return SAFETY_STOCK_ROLES;

    case "MP - AL Contract Automation":
      return AL_CONTRACT_MANAGEMENT_ROLES;

    case "MP - AL Supplier Collaboration":
    case "MP - AL Supplier Collaboration/Confirmation":
    case "MP - Supplier Confirmation":
      return AL_SUPPLIER_COLLABORATION_ROLES;

    case "MP - GR Processing Time Analytics":
      return GRPT_ROLES;

    case "MP - Lead time Analytics":
      return LEAD_TIME_ANALYTICS_ROLES;

    case "MP - AL PO Management":
      return PO_MAINTENANCE_ROLES;

    case "CS - Inventory Rebalancing":
      return INVENTORY_REBALANCING_ROLES;

    case "OM - Load Optimization":
      return OM_LOAD_OPTIMISATION_ROLES;

    case "Command Center":
      // Dynamic cascading roles via Team selection
      return [];

    default:
      return [];
  }
};